import React from 'react';

export default class ChildProgressReviewConfirmDateForm extends React.Component
{
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

		const child = this.props.child == null ? { firstname: '', surname: '' } : this.props.child ;

		this.state = {	loading: true,
						displayErrors: false ,
						displayDropdown: false,
						child: child 
		};
	}

	UNSAFE_componentWillMount()
	{
		this.getChildData ( this.props.child.child_id ) ;
		this.getAvailableReviews( this.props.child.child_id ) ;
	}

	getChildData( child_id )
	{
    	$.ajax({
		  type: 'GET',
		  url: Globals.APIFolder + '/children/' + child_id  + '?include-progress-reviews',
		  data: { },
		  success:(data)=>{
			if ( checkError(data))
			{
				if ( data.status.result == 'success')
				{
					this.setState({ loading: false, child: data.data[0] });
				}
			}
		  },
		  error:(jqXHR, textStatus, error)=>{
				handleAjaxError ( jqXHR, textStatus, error ) ;
		  }
		});
	}


	getAvailableReviews( child_id )
	{
		$.ajax({
			type: 'GET',
			url: Globals.APIFolder + '/reviews/termdates?omit_existing&omit-ungenerated&child_id='+child_id,
			data: { },
			success:(data)=>{
				if ( checkError(data))
				{
					if ( data.status.rowsAffected != 0 )
					{
						this.setState ( { displayDropdown: true }) ;
					}
				}
			},
			error:(jqXHR, textStatus, error)=>{

				handleAjaxError(jqXHR, textStatus, error) ;
			}

		});
	}

    getLastTermCookie()
    {
        var year_term_id = getCookie("selectedterm");

        if (year_term_id != "")
        {
            return year_term_id ;
        }
        else
        {
            setCookie("selectedterm", 1, 100);
        }
    }

    onDropdownTermChange ( id, text )
    {
        setCookie("selectedterm", id , 10);

        this.setState ( { year_term_id: id }) ;
    }

    rowDropdown()
    {
        var lineList = [] ;

        let term_id = null ;

        if ( this.state.child.last_progress_review != null )
		{
            term_id = this.state.child.last_progress_review.half_term_review_id ;
		}

        if ( term_id == null )
		{
			term_id = this.getLastTermCookie();
		}

		const label = term_id = null ? "Select a term" : "Term"  ;

        lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12', style: { marginBottom: '10px'} },
            React.createElement(DropdownProgressReviewTerms, {  key: this.keyCount++,
				validation: { required: true },
				label: label,
				ref: 'InputTerm',
                mode: 'filter',
                defaultItemId: term_id,
				child_id: this.state.child.child_id,
				omitExisting: true,
                callback: this.onDropdownTermChange.bind(this) }, null))) ;

        return React.createElement ( 'div', { className: '', key: this.keyCount++ }, lineList ) ;

    }

	formIsValid ()
	{
		if ( this.refs.InputReviewDate.isValid() && this.refs.InputTerm.isValid())
		{
			return true ;
		}
		else
		{
			return false ;
		}
	}

    getFormData()
    {
        // Copy the data structures for all the available panels
        var data = {} ;

        data.review_date = this.refs.InputReviewDate.getValue() ;
        data.year_term_id = this.refs.InputTerm.getValue() ;

        return data ;
    }

	onSave() 
	{
		if ( this.state.child.last_progress_review != null )
		{
			if ( this.state.child.last_progress_review.submitted == 1 )
			{				
				if ( !this.formIsValid())
				{
					this.setState ( { displayErrors : true })
				}
				else
				{
					if ( this.props.onSave != null )
					{
						// Just pass the click back to the creating form
						this.props.onSave() ;
					}			
				}
			}
			else
			{
				var url = Globals.BaseURL + '/progressreview_update.php?return=' + this.props.return_url + '&review_id=' + this.state.child.last_progress_review.progress_review_id + '&child_id=' + this.state.child.child_id ;

				location.assign ( url ) ;
			}						
		}
		else
		{
			if ( this.props.onSave != null )
			{
				// Just pass the click back to the creating form
				this.props.onSave() ;
			}
		}			
	}
	
	onCancel() 
	{
		if ( this.props.onCancel != null )
		{
			// Just pass the click back to the creating form
			this.props.onCancel() ;
		}
		else
		{
			location.assign('home.php');
		}		
	}

	getFormattedDate(date) 
	{
		  var year = date.getFullYear();
		  var month = (1 + date.getMonth()).toString();
		  month = month.length > 1 ? month : '0' + month;
		  var day = date.getDate().toString();
		  day = day.length > 1 ? day : '0' + day;
		  return day + '/' + month + '/' + year;
	}

	rowChilddDetails()
	{
        var lineList=[];	
		
        if ( this.props.mode == 'create' )
    	{
            var d = this.getFormattedDate (new Date());                 
    	}
        else
    	{
        	var d = "" ;
    	}
        
		var fieldType = "readonly";
		
        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        	  React.createElement ( UserInput, { validation: { required: true, maxlen: 50 },
			  name: 'InputFirstName',
			  ref: 'InputFirstName',
			  labelText: 'First Name', 
			  errorText: 'You must enter a valid first name',
			  value: this.state.child.firstname,
			  readOnly: fieldType, 
			  displayErrors:this.state.displayErrors,
			  key: this.keyCount++
			  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        	  React.createElement ( UserInput, { validation: { required: true, maxlen: 50 },
			  ref: 'InputLastName',
			  name: 'InputLastName',
			  labelText: 'Last Name', 
			  errorText: 'You must enter a valid last name',
			  value: this.state.child.surname,
			  readOnly: fieldType, 
			  displayErrors:this.state.displayErrors,
			  key: this.keyCount++
			  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	historyContainsOpenReviews ( arr )
	{
		return arr.reduce((start, val) =>
		{
			if ( val.review_status == 1 )
			{
				start = true ;
			}

			return start

		}, false );
	}

	rowExistingReviewTable()
	{
		var lineList=[];

		/*
		if ( this.historyContainsOpenReviews( this.state.child.progress_reviews ))
		{
			if ( this.state.displayDropdown == false )
			{
				let info = "There are already incomplete progress reviews in progress for this pupil.";
				lineList.push ( React.createElement('div',  {key: this.keyCount++, style: { marginTop: '15px', color: 'red' }, className: 'col-md-12'}, info ));

				info = "You cannot create any new review requests as there are no other existing review terms available." ;
				lineList.push ( React.createElement('div',  {key: this.keyCount++, style: { marginTop: '15px', color: 'red' }, className: 'col-md-12'}, info ));
			}
			else
			{
				let info = "There are already incomplete progress reviews in progress for this pupil. Before you create a new one, please review the list and consider sending a reminder to the designated teacher." ;
				lineList.push ( React.createElement('div',  {key: this.keyCount++, style: { marginTop: '15px', color: 'red' }, className: 'col-md-12'}, info ));
			}
		}
		else
		{
			if ( this.state.displayDropdown == false )
			{
				let info = "There are no outstanding progress reviews for this pupil. The historical reviews are listed below for information. " ;
				lineList.push ( React.createElement('div',  {key: this.keyCount++, style: { marginTop: '15px' }, className: 'col-md-12'}, info ))

				info = "You cannot create any new review requests as there are no other existing review terms available." ;
				lineList.push ( React.createElement('div',  {key: this.keyCount++, style: { marginTop: '15px', color: 'red' }, className: 'col-md-12'}, info ));
			}
			else
			{
				let info = "There are no outstanding progress reviews for this pupil. The historical reviews are listed below for information. Please select a term from the dropdown below to create a new progress review request for ths pupil." ;
				lineList.push ( React.createElement('div',  {key: this.keyCount++, style: { marginTop: '15px' }, className: 'col-md-12'}, info ))
			}
		}
		*/

		var returnUrl = btoa('create_progressreview.php?childid=' + this.props.child.child_id + '&return=' + this.props.return_url ) ;

		lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-12'},
			React.createElement ( ProgressReviewTable, { key: this.keyCount++, return_url: returnUrl, child_id: this.props.child.child_id, data: this.state.child.progress_reviews, externalData: true }))) ;

		return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	rowExistingReviewInProgress()
	{
        var lineList=[];	
		
		var showDate = true ;

        if ( this.state.displayDropdown == true )
		{
			if ( showDate == true )
			{
				lineList.push ( this.row2()) ;
			}

			lineList.push(this.rowDropdown()) ;
		}

        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	row2()
	{
        let lineList=[];
		
        const d = this.props.mode == 'create' ? this.getFormattedDate (new Date()) : this.state.child.dmy_date_of_birth ;

		const fieldType = this.props.readonly == true || this.state.mode == 'view' ? 'readonly' : '' ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        	  React.createElement ( UserInput, { validation: { required: true, maxlen: 10, isDate: true },
			  id: 'InputReviewDate', 
			  name: 'InputReviewDate',
			  ref: 'InputReviewDate',
			  labelText: 'Review Date', 
			  errorText: 'You must enter a valid reviewDate',
			  value: d,
			  readOnly: fieldType, 
			  displayErrors:this.state.displayErrors,
			  key: this.keyCount++
			  }))) ;

		lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'})) ;
		
        return React.createElement('div',  {key: this.keyCount++, className: 'row', style: { paddingLeft: '15px'}}, lineList );
	}	
	
	buttonElement ( buttonText, clickHandler )
	{
        return React.createElement('button', { id: 'getButtonReact', type: 'button', className: 'btn btn-primary', onClick: clickHandler }, buttonText) ;
	}
		
	formRow ()
    {
        return React.createElement('div', { key: this.keyCount++}, this.col1FieldList(), this.col2FieldList()) ;
    }

	buttonRow ()
    {
        var lineList=[];

        const saveButtonText = this.state.child.last_progress_review != null && this.state.child.last_progress_review.submitted != 1 ? 'Open Existing Review' : 'Confirm' ;

        lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-8'},null)) ;

		if ( this.state.displayDropdown == true ) {
			lineList.push(React.createElement('div', {key: this.keyCount++, className: 'col-md-4'},
				React.createElement('button', {
					id: 'SaveButton',
					type: 'button',
					className: 'btn btn-primary',
					style: {float: 'right'},
					onClick: this.onSave.bind(this)
				}, saveButtonText),
				React.createElement('button', {
					id: 'CancelButton',
					type: 'button',
					className: 'btn btn-secondary',
					style: {float: 'right', marginRight: '10px'},
					onClick: this.onCancel.bind(this)
				}, 'Cancel')))
		}
		else
		{
			lineList.push(React.createElement('div', {key: this.keyCount++, className: 'col-md-4'},
				React.createElement('button', {
					id: 'CancelButton',
					type: 'button',
					className: 'btn btn-secondary',
					style: {float: 'right', marginRight: '10px'},
					onClick: this.onCancel.bind(this)
				}, 'Return')))
		}
           		        
        return React.createElement('div', { className: 'row panel-body', key: this.keyCount++ }, lineList ); 
    }
    
	mainFormElement ()
    {
	    var lineList=[];
	    
	    lineList.push ( this.rowChilddDetails()) ;

	    if ( this.state.child.progress_reviews != null )
		{
			lineList.push ( this.rowExistingReviewTable()) ;
		}

	    lineList.push ( this.rowExistingReviewInProgress()) ;

	    lineList.push ( this.buttonRow()) ;
	    
	    return lineList;
    }

	render() 
    {
		this.keyCount=0;

		if ( this.state.loading == true )
    	{
	        return React.createElement(SpinnerDiv);
    	}
    	else
    	{
			return React.createElement('div', { className: 'panel'},
					React.createElement ('div', { className: 'panel-body'}, this.mainFormElement()));
    	}
    }
};